import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Initialize state from localStorage
const token = localStorage.getItem('token');
const user = localStorage.getItem('user');
const userRole = localStorage.getItem('userRole');
const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

const initialState = {
  isAuthenticated: isAuthenticated && !!token,
  user: user || '',
  userRole: userRole || '',
  token: token || '',
  loading: false,
  registerSuccess: false,
  registerError: '',
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    login: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.error = null;
    },
    fetchUserProfile: (state, action) => {
      state.userRole = action.payload.role;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload.userRole;
    },
    logout: (state) => {
      state.loading = false;
      state.token = '';
      state.userRole = '';
      state.isAuthenticated = false;
      state.user = '';
      state.error = null;
      
      // Clear localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userRole');
    },
    registerSuccess: (state) => {
      state.loading = false;
      state.registerSuccess = true;
      state.registerError = '';
    },
    registerError: (state, action) => {
      state.loading = false;
      state.registerSuccess = false;
      state.registerError = action.payload;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setUserRole,
  login,
  logout,
  fetchUserProfile,
  registerSuccess,
  registerError,
  setError,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;

// Async thunk for fetching user data
export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/user', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return { userData: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch user data');
    }
  }
);

// Async thunk for login
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post('https://api.learnxtrasoftwares.com/api/login', credentials);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Login failed');
    }
  }
);